<script setup>
const route = useRoute()
const router = useRouter()
const props = defineProps({
  items: { type: Array, default: () => ([]) }
})

console.log(props.items)
const { $dayjs } = useNuxtApp()
const { loading, isLoading } = useLoading()
const { getProducers } = useDatabase()

const isRanking = computed(() => route.query.l == 'popularity')
const isNewest = computed(() => route.query.l == 'newest')

onMounted(() => {
  window.addEventListener('scroll', handleReachedBottom);

  getItemsByPage(route.query).then(resp => {
    // console.log(resp)
    producers.value = resp
  }).catch(e => {
    console.error(e)
  }).finally(_ => {
    loading.stop()
  })

  console.log(producers.value)
});

onUnmounted(() => window.removeEventListener('scroll', handleReachedBottom));


const handleReachedBottom = () => {
  const { scrollTop, scrollHeight, clientHeight } = document.documentElement;

  // ページが最下部に達した場合のチェック
  if (scrollTop + clientHeight >= scrollHeight) {
    if (!isMaxPage.value && !['newest','popularity'].includes(route.query?.l)) {
      handleChangeQuery()
    } else {
      console.log('全データを取得しました。')
    }
  }
}

const handleChangeQuery = () => {
  router.push({
    query: {
      p: Number(route.query.p || 1) + 1,
      c: route.query.c || '',
      l: route.query.l,
      s: route.query.s,
    }
  })
}

const getItemsByPage = async query => await getProducers({
  member: 1,
  take: Number(query.p || 1) * 12,
  c: query.c,
  l: query.l,
  s: query.s,
})

onBeforeRouteUpdate((to, from, next) => {
  loading.start()

  getItemsByPage(to.query).then(resp => {
    // console.log(resp)
    producers.value = resp
  }).catch(e => {
    console.error(e)
  }).finally(_ => {
    loading.stop()
    next()
  })
})

const producers = ref(await getItemsByPage(route.query))

const isMaxPage = computed(() => {
  const $prodItems = producers.value.items
  const $prodPage = producers.value.page
  return $prodItems.length == $prodPage.totalCount
})

const topFirstCategory = (producer) => {
  const categories = producer.categories
  if (producer.top_category) {
    return categories.find(v => v.id == producer.top_category)
  } else if (producer.categories) {
    const topCategories = categories.filter(v => !v.parent_id)
    return producer.top_category || topCategories[0]
  }
}

const isNew = (producer) => {
  if (producer?.created_at) {
    const now = $dayjs()
    const date = producer?.created_at
    const oneMonthAgo = now.subtract(1, 'month');
    return $dayjs(date).isAfter(oneMonthAgo) && $dayjs(date).isBefore(now);
  }
}
</script>


<template>
  <div>
    <default-page-list-newest
      v-if="isNewest"
      :items="producers.items"
    />
    <default-page-list-ranking
      v-if="isRanking"
      :items="producers.items"
    />

    <div v-if="!(isNewest || isRanking)">
      <div
        v-if="producers.items?.length"
        class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2 sm:gap-3 lg:gap-6 mb-12"
      >
        <default-page-list-item
          v-for="(producer, p) of producers.items"
          :key="p"
          :item="producer"
          :is-new="isNew(producer)"
          :top-category="topFirstCategory(producer)"
        />

        <div
          v-if="!isMaxPage"
          class="text-center col-span-full mt-20"
        >
          <button
            type="button"
            class="btn btn-primary btn-sm"
            @click="handleChangeQuery"
          >続きを表示</button>
        </div>
      </div>

      <p
        v-else
        class="text-center text-xl font-noto-serif mt-0 lg:mt-16"
      >生産者が見つかりませんでした。</p>

      <input type="hidden" :value="isMaxPage" />
    </div>
  </div>
</template>